/**
 * Client-minted replay keys: collision-resistant enough for a per-device queue,
 * readable enough that an operator can match one in an audit log to the tap
 * that made it. The id is the *only* thing that makes a re-delivery safe, so it
 * must be minted once, when the work is accepted — never regenerated on retry.
 */
export function newOperationId(prefix?: string): string {
  const chunk = () => Math.random().toString(36).slice(2, 10);
  const stamp = Date.now().toString(36);
  // Two historical formats, both kept: the staff apps that name a prefix put it
  // in front so an id is traceable to the device class that minted it, and the
  // apps that do not keep the longer, unprefixed form they have always emitted.
  return prefix ? `${prefix}-${stamp}-${chunk()}` : `op_${stamp}_${chunk()}${chunk()}`;
}
